exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.graph #cytoscape-div {\n    height: calc(100vh - 68px) !important;\n    width: auto;\n}\n.addressClusterTransactionViewGraph #cytoscape-div {\n    height: calc(100vh - 68px - 49px) !important;\n    width: auto;\n}\n\n", ""]);
